import { useI18n } from "@/i18n";

export const betaRelease = process.env.REACT_APP_BETA_RELEASE === "true";

export function BetaNotice() {
  const { t } = useI18n();
  if (!betaRelease) return null;
  return <aside aria-label={t("beta.label")} data-testid="beta-notice"
    className="border-b border-ax-border bg-ax-surface px-4 py-3 text-center text-xs leading-5 text-ax-text-2 md:px-20 lg:px-60">
    <strong className="font-semibold">{t("beta.label")}</strong>{" · "}{t("beta.notice")}
  </aside>;
}
